import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { AppContext, DispatchContext } from "../AppContext";
import * as actions from "../actions/actions";
import { config, resolveNotificationMessage } from '../helpers/constants';
import Service from "../services/service";
import { ReactComponent as UsersIcon } from '../assets/icons/team.svg';
import { ReactComponent as CertificateIcon } from '../assets/icons/certificate.svg';
import { ReactComponent as TeacherIcon } from '../assets/icons/teacher.svg';
import { ReactComponent as CheckedIcon } from '../assets/icons/checked.svg';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Link, Select, Paper, Grid, Box, Typography, InputLabel, FormControl, Button, Tab, Tabs, AppBar, Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem } from "@material-ui/core";
import IconLabel from './IconLabel';
import PriceCard from './PriceCard';
import LicenseQuotePanel from './LicenseQuotePanel';
import CheckoutLoginPanel from './CheckoutLoginPanel';
import CheckoutInvoiceAddressPanel from './CheckoutInvoiceAddressPanel';
import CheckoutSelectPaymentPanel from './CheckoutSelectPaymentPanel';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}


export default function PaymentDialog(props) {

    const useStyles = makeStyles((theme) => ({
        dialogContent: {
            borderTop: "1px solid #eeeeee",
            borderBottom: "1px solid #eeeeee",
            height: "590px",
            width: "875px",
            padding: 0
        },
        tabContent: {
        },
        paper: {
            height: "280px",
            width: 100,
        },
        tab: {
            textTransform: "none !important",
        },
        marginPaper: {
            marginLeft: "50px",
            marginRight: "50px",
            minHeight: "100px",
        },

    }));


    const state = useContext(AppContext);
    const s = state.strings;
    const dispatch = useContext(DispatchContext);
    const classes = useStyles();
    const [selectedTab, setSelectedTab] = useState(0);
    const { disableBackdrop, onClose, onQuoteSent, preselectedProductId } = props;


    useEffect(() => {
        // disallow payment access for users with unlimited educational license except for payment (step 4) 
        if ((state.ui.paymentDialogVisible) && (state.user.license.type == 1) && (state.user.license.remaining == -1) && (state.checkout.paymentStep < 4)) {
            dispatch(actions.openConfirmationDialog({
                title: s.paymentDialog.educationalLicense,
                text: s.paymentDialog.educationalLicenseText,
                hint: s.paymentDialog.educationalLicenseHint,
                onCancel: () => { handleClose() }
            }));
        }

        // preselect free package for guests
        if (state.user.guest && !state.checkout.productId) {
            dispatch(actions.setCheckoutDetails({ productId: 30110 }));
        }

        if (preselectedProductId) {
            var packs = [30111, 30112, 30113, 30114];
            var subscriptions = [30501, 30502, 30503];
            var yearly = [30501, 30502, 30503];
            var validIds = [...subscriptions, ...packs];
            var pId = validIds.includes(preselectedProductId) ? preselectedProductId : 0;
            var term = "yearly"; //yearly.includes(pId) ? "yearly" : "monthly";
            if (subscriptions.includes(pId)) {
                setSelectedTab(1);
            }
            if (preselectedProductId == 30801) {
                setSelectedTab(2);
            }
            dispatch(actions.setCheckoutDetails({ paymentStep: 0, productId: pId, paymentId: null, withdrawalConsentChecked: false, term: term, file: {}, invoiceId: null }));
        }

    }, [state.ui.paymentDialogVisible]);


    const handleProductChange = (newProductId) => {
        dispatch(actions.setCheckoutDetails({ productId: newProductId, invoiceId: null }));
    }

    const handleNextStep = () => {
        switch (state.checkout.paymentStep) {
            case 0: // select Product
                switch (selectedTab) {
                    case 0:
                    case 1:
                        let nextStep = state.checkout.paymentStep + ((state.user.guest || !state.user.loggedIn) ? 1 : 2);
                        dispatch(actions.setCheckoutDetails({ paymentStep: nextStep }));
                        break;
                    case 2: // education license
                        Service.sendQuoteMail(state.checkout.education).then(res => {
                            if (res.success) {
                                dispatch(actions.openPaymentDialog(false));
                                dispatch(actions.setCheckoutDetails({ education: {} }));
                                dispatch(actions.openToast({ type: "success", message: resolveNotificationMessage(res.message, s.notificationMessage) }));
                                onQuoteSent && onQuoteSent();
                            } else {
                                dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
                            }
                        });
                }
                break;
            case 2: // Update invoice address (only filled out fields to make sure possibly expired lices code does not cause an error message in backend)
                Service.updateUser({ name: state.user.name, companyName: state.user.companyName, address1: state.user.address1, address2: state.user.address2, zip: state.user.zip, city: state.user.city, country: state.user.country, vatId: state.user.vatId }).then(res => {
                    if (res.success) {
                        dispatch(actions.setCheckoutDetails({ paymentStep: state.checkout.paymentStep + 1 }));
                        Service.getUserInfo().then(getInfoRes => {
                            dispatch(actions.setUserDetails(getInfoRes.data));
                        });
                    } else {
                        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
                    }
                });
                break;
            case 3: // place order 
                dispatch(actions.showFullscreenLoading(true));
                Service.createOrder(state.checkout.products.find(p => { return p.id === state.checkout.productId }), state.checkout.currency, state.checkout.paymentId, state.checkout.taxIncluded, state.checkout.taxMode, state.checkout.vatRate).then(res => {
                    processPayment(res);
                });
                break;
            case 4: // pay 
                dispatch(actions.showFullscreenLoading(true));
                Service.createPayment(state.checkout.invoiceId, state.checkout.paymentId).then(res => {
                    processPayment(res);
                });
                break;
            case 5:
                dispatch(actions.openPaymentDialog(false));
                break;
            default:
                dispatch(actions.setCheckoutDetails({ paymentStep: state.checkout.paymentStep + 1 }));
        }
    }

    const processPayment = (res) => {
        if (res.success) {
            if (res.data.payment && res.data.payment._links && res.data.payment._links.checkout) {
                // Redirect to Mollie-hosted checkout (user must complete payment there).
                // Keep the loading spinner visible during the redirect to avoid a flash of the
                // payment dialog. The spinner is cleared by the pageshow listener in AppRouter
                // when the user returns via the browser "back" button (bfcache restore).
                // Store the invoiceId so AppRouter can navigate to /checkout/{id} on back,
                // preventing the user from accidentally triggering a new order.
                if (res.data.invoiceId) {
                    sessionStorage.setItem('mollieCheckoutInvoiceId', res.data.invoiceId);
                }
                let url = res.data.payment._links.checkout.href;
                dispatch(actions.navigate_to(url));
            } else {
                // No Mollie-hosted checkout link (e.g. mandate/recurring payment).
                // Navigate to the checkout handler which will show the result.
                dispatch(actions.showFullscreenLoading(false));
                let url = config.frontendUrl + "checkout/" + res.data.invoiceId;
                dispatch(actions.navigate_to(url));
            }
        } else {
            dispatch(actions.showFullscreenLoading(false));
            dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
        }
    }


    const handlePrevStep = () => {
        if (state.checkout.paymentStep == 4) {
            dispatch(actions.openConfirmationDialog({
                title: s.paymentDialog.cancelPaymentTitle,
                text: s.paymentDialog.cancelPaymentText,
                onConfirm: () => handleClose(),
                hint: s.paymentDialog.cancelPaymentHint
            }));
        } else if (state.checkout.paymentStep == 2) {
            dispatch(actions.setCheckoutDetails({ paymentStep: state.checkout.paymentStep - 2 }));
        } else {
            dispatch(actions.setCheckoutDetails({ paymentStep: state.checkout.paymentStep - 1 }));
        }
    }

    const handleClose = () => {
        dispatch(actions.setCheckoutDetails({ paymentStep: 0, productId: null, paymentId: null, term: "yearly", file: {}, invoiceId: null }));
        dispatch(actions.openPaymentDialog(false));
        onClose && onClose(selectedTab);
    }

    const handleSelectedTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        handleProductChange(null);
    }

    const handleCheckoutChange = (newValue, key) => {
        dispatch(actions.setCheckoutDetails({ [key]: newValue }));

        // remove selected product if month/year terms have changed to provent unwanted ordering of wrong terms
        if (key == "term") {
            handleProductChange(null);
        }

    }

    const nextButtonText = () => {
        switch (state.checkout.paymentStep) {
            case 0: // select Product
                switch (selectedTab) {
                    case 2:
                        return s.paymentDialog.sendQuote;
                    default:
                        return s.paymentDialog.continue;
                }
            case 1: // login
            case 2: // invoice address
                return s.paymentDialog.continue;
            case 3: // purchase
                return s.paymentDialog.purchase;
            case 4: // pay
                return s.paymentDialog.pay;
            case 5: // paid
                return s.paymentDialog.close;
            default:
                return s.paymentDialog.continue;
        }
    }

    const nextButtonEnabled = () => {
        switch (state.checkout.paymentStep) {
            case 0: // select Product
                switch (selectedTab) {
                    case 2: // education License
                        return Boolean(state.checkout.education.complete);
                    default:
                        return Boolean(state.checkout.productId);
                }
            case 1: // login
                return Boolean(state.checkout.loginComplete);
            case 2: // invoice address
                return Boolean(state.user.invoiceAddressComplete);
            case 3: { // select payment
                const product = state.checkout.products.find(p => p.id === state.checkout.productId);
                const needsConsent = product && product.categoryId === 1 && !state.checkout.invoiceId;
                return Boolean(state.checkout.paymentId) && (!needsConsent || state.checkout.withdrawalConsentChecked);
            }
            case 4:
                return Boolean(state.checkout.paymentId);
            default:
                return true;
        }
    }

    const onDownloadInvoiceClicked = (id) => {
        const url = config.backendUrl + "export/?rid=" + id;
        window.open(url, "_blank");
    }

    const dialogTitle = () => {
        switch (state.checkout.paymentStep) {
            case 0:
                return s.paymentDialog.step0Title;
            case 1:
                return s.paymentDialog.step1Title;
            case 2:
                return s.paymentDialog.step2Title;
            case 3:
                return s.paymentDialog.step3Title;
            case 4:
                return s.paymentDialog.step4Title;
            case 5:
                return s.paymentDialog.step5Title;
            default:
                return "";
        }
    }

    return (
        <div>
            <Dialog
                className={classes.root}
                open={state.ui.paymentDialogVisible}
                onClose={handleClose}
                disableBackdropClick
                maxWidth={false}

                hideBackdrop={disableBackdrop ? true : false}
                disableEnforceFocus={disableBackdrop ? false : true}
                style={disableBackdrop ? { pointerEvents: 'none' } : {}}
                PaperProps={disableBackdrop ? { style: { pointerEvents: 'auto' } } : {}}
            >
                <DialogTitle>{dialogTitle()}</DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    {(state.checkout.paymentStep === 0) && <>
                        <AppBar position="static" color="default">
                            <Tabs
                                className={classes.tabs}
                                value={selectedTab}
                                onChange={handleSelectedTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                centered
                            >
                                <Tab className={classes.tab} label={s.paymentDialog.prepaidCredits} icon={<UsersIcon height={60} width={60} />} />
                                {(state.user.license.type != 1) && <Tab className={classes.tab} label={state.user.license.type == 2 ? s.paymentDialog.modifyLicense : s.paymentDialog.volumeLicense} icon={<CertificateIcon height={60} width={60} />} />}
                                {(state.user.license.type != 1) && <Tab className={classes.tab} label={s.paymentDialog.educationalLicenseRequest} icon={<TeacherIcon height={60} width={60} />} />}
                            </Tabs>
                        </AppBar>
                        <TabPanel value={selectedTab} index={0}>
                            <Grid container justify="center" alignContent="center" spacing={2}>
                                <Grid item>
                                    {state.user.license.type == 2 && <IconLabel type="warning" mb={24} label={s.paymentDialog.prepaidVolumeHint} />}
                                    {!state.user.license.code && <IconLabel mb={24} label={s.paymentDialog.prepaidCreditsHint} />}
                                </Grid>
                            </Grid>
                            <Box m={1} />
                            <Grid container justify="center" spacing={1}>
                                {state.checkout.products.filter(p => p.categoryId == 1).map((price) => (
                                    <Grid item key={price.id}>
                                        {((price.id !== 30110) || (state.user.guest)) &&
                                            <PriceCard title={price.nameShort} text1={s.paymentDialog.priceCardCredits.format(price.credits)} text2={s.paymentDialog.priceCardPages.format(price.credits)}
                                                text3={price.users}
                                                price={price.cost[state.checkout.currency]}
                                                currency={state.checkout.currency}
                                                selected={state.checkout.productId === price.id}
                                                productId={price.id}
                                                handleChange={handleProductChange}
                                                taxIncluded={state.checkout.taxIncluded}
                                                vatRate={state.checkout.vatRate}
                                            />}
                                    </Grid>
                                ))}
                            </Grid>
                            <Box p={1} />
                            <Grid direction="column" container justify="center" alignItems="center" spacing={3}>
                                <Grid item>
                                    <FormControl variant="outlined">
                                        <InputLabel >{s.paymentDialog.currency}</InputLabel>
                                        <Select
                                            onChange={(e) => handleCheckoutChange(e.target.value, 'currency')}
                                            label={s.paymentDialog.currency}
                                            value={state.checkout.currency}
                                        >
                                            <MenuItem value={"USD"}>USD</MenuItem>
                                            <MenuItem value={"EUR"}>EUR</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item>
                                    <Typography variant="body2" color="secondary">{s.paymentDialog.oneOffPurchase}</Typography>
                                </Grid>
                            </Grid>
                        </TabPanel>
                        <TabPanel value={selectedTab} index={1}>
                            { /* user is license admin but license has not been paid yet */
                                state.user.license.code && !state.user.license.paid && state.user.license.adminUserId == state.user.userId ?
                                    <IconLabel mt={64} centered label={s.paymentDialog.cannotModifyNotPaid} /> :
                                    /* user has license but is not license admin */
                                    state.user.license.code && state.user.license.adminUserId != state.user.userId ?
                                        <IconLabel mt={64} spacing={64} centered label={s.paymentDialog.cannotModifyNotAdmin} /> :
                                        /* All good, display plans */
                                        <>
                                            <Grid container justify="center" alignContent="center" spacing={2}>
                                                <Grid item>
                                                    {state.user.license.type == 2 && state.user.license.valid && <IconLabel type="warning" label={s.paymentDialog.linkedToValidVolume.format(state.user.license.remaining)} />}
                                                    {state.user.license.type == 2 && !state.user.license.valid && <IconLabel type="info" label={s.paymentDialog.linkedtoInvalidVolume} mb={16} />}
                                                    {!state.user.license.code && <IconLabel mb={24} label={s.paymentDialog.volumeLicenseHint} />}
                                                </Grid>
                                            </Grid>
                                            <Box m={1} />
                                            <Grid container justify="center" spacing={1}>
                                                {state.checkout.products.filter(p => p.categoryId == (state.checkout.term == "monthly" ? 3 : 5)).map((price) => (
                                                    <Grid key={price.id} item>
                                                        <PriceCard title={price.nameShort} text1={price.credits + " ScanCredits " + (state.checkout.term == "monthly" ? s.paymentDialog.perMonth : s.paymentDialog.perYear)} text2={s.paymentDialog.unlimitedUsers}
                                                            text3={price.users}
                                                            price={price.cost[state.checkout.currency]}
                                                            currency={state.checkout.currency}
                                                            selected={state.checkout.productId === price.id}
                                                            productId={price.id}
                                                            handleChange={handleProductChange}
                                                            taxIncluded={state.checkout.taxIncluded}
                                                            vatRate={state.checkout.vatRate}
                                                        />
                                                    </Grid>
                                                ))}
                                            </Grid>
                                            <Box p={1} />
                                            <Grid container direction="column" alignItems="center" spacing={1}>
                                                <Grid item>
                                                    <TextField style={{ display: "none", width: 275, marginRight: 8 }} select variant="outlined" label={s.paymentDialog.renewalTerms} value={state.checkout.term} onChange={(e) => handleCheckoutChange(e.target.value, 'term')}>
                                                        <MenuItem value={"monthly"}>{s.paymentDialog.monthly}</MenuItem>
                                                        <MenuItem value={"yearly"}>{s.paymentDialog.yearly}</MenuItem>
                                                    </TextField>
                                                    </Grid>
                                                    <Grid item>
                                                    <FormControl variant="outlined">
                                                        <InputLabel>{s.paymentDialog.currency}</InputLabel>
                                                        <Select
                                                            onChange={(e) => handleCheckoutChange(e.target.value, 'currency')}
                                                            label={s.paymentDialog.currency}
                                                            value={state.checkout.currency}
                                                        >
                                                            <MenuItem value={"USD"}>USD</MenuItem>
                                                            <MenuItem value={"EUR"}>EUR</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>

                                                <Grid item>
                                                    <Typography variant="body2" color="secondary">{s.paymentDialog.renewHint}</Typography>
                                                </Grid>
                                            </Grid>
                                        </>}
                        </TabPanel>
                        <TabPanel value={selectedTab} index={2}>
                            <LicenseQuotePanel onQuoteSent={onQuoteSent} />
                        </TabPanel>
                        <TabPanel value={selectedTab} index={3}>
                            <Grid container justify="center" alignContent="center" spacing={2}>
                                <Grid item>
                                    <IconLabel label={s.paymentDialog.provideMailAddress} />
                                </Grid>
                            </Grid>
                            <Box p={3} />
                            <Paper style={{ backgroundColor: "#eeeeee" }}>
                                <Box p={1} />
                                <Grid container direction="column" justify="center" spacing="4" alignItems="flexstart">
                                    <Grid item>
                                        <TextField style={{ width: "90%" }}
                                            size="small"
                                            required
                                            label={s.common.mailAddress}
                                            value={state.user.mail}
                                            disabled={(state.user.mail !== "guest@plagaware.com")}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <TextField style={{ width: "90%" }}
                                            size="small"
                                            required
                                            label={s.common.mailAddress}
                                            value={state.user.mail}
                                            disabled={(state.user.mail !== "guest@plagaware.com")}
                                        />
                                    </Grid>
                                </Grid>
                                <Box p={1} />
                            </Paper>
                        </TabPanel>
                    </>
                    }
                    {(state.checkout.paymentStep === 1) &&
                        <CheckoutLoginPanel />
                    }
                    {(state.checkout.paymentStep === 2) &&
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <CheckoutInvoiceAddressPanel />
                            <Typography style={{ marginTop: 48 }} variant="body2" color="secondary">{s.paymentDialog.provideCountry}</Typography>
                        </div>}
                    {(state.checkout.paymentStep === 3) && <>
                        <CheckoutSelectPaymentPanel />
                    </>}
                    {(state.checkout.paymentStep === 4) && <>
                        <CheckoutSelectPaymentPanel type="payInvoice" />
                    </>}
                    {(state.checkout.paymentStep === 5) && <>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", padding: 60 }}>
                            <Box mt={5} />
                            <CheckedIcon style={{ fill: '#009900' }} height={100} width={100} />
                            <Box mt={4} />
                            <Typography variant="h6" color="primary" paragraph>{s.paymentDialog.thanksForPurchase}</Typography>
                            {(state.checkout.paymentStatus == "paid") ?
                                <>
                                    <IconLabel label={s.paymentDialog.paymentCompleted} />
                                    <Box mt={1} />
                                    <Typography align="center">{s.paymentDialog.creditsAdded}</Typography>
                                </>
                                :
                                <>
                                    <IconLabel label={s.paymentDialog.paymentInitiated} />
                                    <Box mt={1} />
                                    <Typography align="center">{s.paymentDialog.creditsAddedWhenPaymentCompleted}</Typography>
                                    <Box mt={2} />
                                    <Link href="#" onClick={handlePrevStep} align="center">{s.paymentDialog.paymentPending}</Link>
                                </>
                            }
                            {state.checkout.invoiceId &&
                                <>
                                    <Box mt={3} />
                                    <Button variant="outlined" onClick={() => onDownloadInvoiceClicked(state.checkout.invoiceId)}>{s.paymentDialog.downloadInvoice}</Button>
                                </>
                            }
                        </div>
                    </>}


                </DialogContent>
                <DialogActions >
                    {(state.checkout.paymentStep < 5) &&
                        <Button onClick={(state.checkout.paymentStep == 0) ? handleClose : handlePrevStep} variant="outlined" color="primary">
                            {((state.checkout.paymentStep == 0) || (state.checkout.paymentStep == 4)) ? s.common.cancel : s.common.back}
                        </Button>
                    }
                    <Button onClick={handleNextStep} variant="contained" color="primary" endIcon={<NavigateNextIcon />} autoFocus disabled={!nextButtonEnabled()}>
                        {nextButtonText()}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}